export const Constant = {
    ls_referral_code:"referral_code"
}